import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleStorageService {

  constructor(
    protected http: HttpClient
  ) { }

  public upload(file): Observable<any> {
    var formData: FormData = new FormData();
    formData.append('files', file);
    return this.http.post<any>( environment.baseUrl + 'mia-core/upload-files', formData);
  }
}
